import {ApprovalStep} from "@/models/approvalStep";
import {BankAccount, Vendor} from "@/models/vendor";
import {Rechnung} from "@/models/rechnung";

export class Voucher {
  id?: any;
  createDate?: any;
  modifyDate?: any;
  creator?: string;
  status?: any;
  paymentBankAccount?: BankAccount;
  approvalStepList?: ApprovalStep[];
  description?: string;
  advanceReceived?: boolean;
  advanceAmount: string;
  mainExpense?: string;
  subMainExpense? : string;
  subSubMainExpense? : string;
  department?: string;
  purposeOfExpense?: string;
  voucherCostsSet?: VoucherKosten[];
  selectedPaymentBankAccountId?: number;
  purposeOfTransfer?: string;
  shobaMuhasibComment?: string;
  shobaComment?: string;
  gesamtBetrag?: number;
  signedByMoatmad?: boolean;
  signedByEconomicalOperation?: boolean;
  internalId?: string;
  majlis?: string;
  region?: string;
  attendance?: string;
  createdByMohtamim?: string;
  createdByMoawinMuhasib?: string;

  payedInstitut?: string;
  payedIban?: string;
  payedBic?: string;
  payedAccountHolder?: string;
  type?: string;
}


export interface VoucherKosten {
  id?: any,
  createDate?: any,
  modifyDate?: any,
  expenseHead?: string,
  subExpenseHead?: string,
  subSubExpenseHead?: string,
  amount?: any,
}

